
    import './styles.scoped.css';
    export default {
  "tutorial-list": "awsui_tutorial-list_1u70p_75q8o_181",
  "tutorial-title": "awsui_tutorial-title_1u70p_75q8o_217",
  "task": "awsui_task_1u70p_75q8o_224",
  "task-title": "awsui_task-title_1u70p_75q8o_232",
  "task-title--status": "awsui_task-title--status_1u70p_75q8o_240",
  "current-task": "awsui_current-task_1u70p_75q8o_244",
  "successful-task": "awsui_successful-task_1u70p_75q8o_248",
  "congratulation-message": "awsui_congratulation-message_1u70p_75q8o_252",
  "congratulation-message--status": "awsui_congratulation-message--status_1u70p_75q8o_260",
  "plaintext-congratulation-description": "awsui_plaintext-congratulation-description_1u70p_75q8o_265",
  "divider": "awsui_divider_1u70p_75q8o_269",
  "step-list": "awsui_step-list_1u70p_75q8o_273",
  "step": "awsui_step_1u70p_75q8o_273",
  "expandable-section-wrapper": "awsui_expandable-section-wrapper_1u70p_75q8o_284",
  "expandable-section-header": "awsui_expandable-section-header_1u70p_75q8o_288",
  "step-title": "awsui_step-title_1u70p_75q8o_293",
  "feedback-link": "awsui_feedback-link_1u70p_75q8o_294",
  "dismiss-button": "awsui_dismiss-button_1u70p_75q8o_295",
  "completion-screen-title": "awsui_completion-screen-title_1u70p_75q8o_296",
  "completion-screen-description": "awsui_completion-screen-description_1u70p_75q8o_297"
};
  